import { Users, Sparkles, FileText, Mail, Shield, Zap } from "lucide-react";

const Features = () => {
  return (
    <section id="features" className="py-16 bg-secondary/30">
      <div className="container px-6 mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-3">
            Built for the manager who hates chasing updates
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            One tool. Collects from your team, writes the summary, exports the report.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          <FeatureItem
            icon={<Users className="w-6 h-6" />}
            title="No login headaches"
            description="Each person gets their own link. They click, fill it out, submit. No account, no password, no friction."
          />
          <FeatureItem
            icon={<Mail className="w-6 h-6" />}
            title="One click to reach everyone"
            description="Hit send. Every contributor gets a personalized request. Stragglers get a reminder automatically."
          />
          <FeatureItem
            icon={<Sparkles className="w-6 h-6" />}
            title="The summary writes itself"
            description="Raw responses go in. A clean, executive-ready report comes out. Bullets, metrics, risks — all organized."
          />
          <FeatureItem
            icon={<FileText className="w-6 h-6" />}
            title="Ready to share in one click"
            description="PDF, formatted, professional. Drop it in an email or print it for the meeting."
          />
          <FeatureItem
            icon={<Shield className="w-6 h-6" />}
            title="Your data stays yours"
            description="Every link is unique and encrypted. Submissions are locked to the right person. Nothing leaks."
          />
          <FeatureItem
            icon={<Zap className="w-6 h-6" />}
            title="Set it up once"
            description="Build your template. Run it every month. Change nothing unless you want to."
          />
        </div>
      </div>
    </section>
  );
};

const FeatureItem = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => {
  return (
    <div className="p-5 rounded-lg bg-card border border-border/60 transition-colors duration-200 hover:border-border">
      <div className="w-11 h-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-3">
        {icon}
      </div>
      <h3 className="font-semibold text-foreground mb-1.5">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
};

export default Features;
